import {register} from '@shopify/theme-sections';

register('blog-template-recipe', {
  onLoad() {
  },
});
